import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'

import Service from '@/common/plugins/service';
import Storage from '@/common/plugins/storage';

Vue.use(Storage);

Vue.use(Service, {
  apiUrl: process.env.VUE_APP_API_SEGURIDAD_URL,
  authToken: process.env.VUE_APP_AUTH_TOKEN,
  docUrl: process.env.VUE_APP_API_SEGURIDAD_DOC_URL,
});

Vue.use(VueProgressBar, {
  color: '#37696E',
  failedColor: '#fc4b6c',
  thickness: '5px'
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
